import { Vault } from '@phosphor-icons/react';

import { WizardStepHeader } from '../../wizard';
import pt from '../../../locales/pt';
import { cn } from '../../../utils/cn';

/**
 * Cofre SMART opcional — blindar o extra mensal.
 */
export function DebtVaultStep({ extraAmount, enabled, onToggle }) {
  const copy = pt.liabilities.repaymentWizard.vault;
  const amountFmt = Math.round(Number(extraAmount) || 0).toLocaleString('pt-PT');

  return (
    <div className="flex flex-col gap-3.5 pt-1.5">
      <WizardStepHeader
        eyebrow={copy.eyebrow}
        title={copy.title}
        subtitle={copy.subtitle}
      />

      <button
        type="button"
        onClick={() => onToggle(!enabled)}
        className={cn(
          'w-full rounded-[18px] border-[1.5px] p-4 text-left transition-colors',
          enabled
            ? 'border-sage-500 bg-card shadow-[0_0_0_3px_rgba(244,247,240,1)] dark:shadow-[0_0_0_3px_rgba(74,98,67,0.25)]'
            : 'border-border bg-card',
        )}
      >
        <div className="flex items-center gap-3">
          <span
            className={cn(
              'flex h-11 w-11 shrink-0 items-center justify-center rounded-[13px]',
              enabled
                ? 'bg-sage-100 text-sage-800 dark:bg-sage-900/50 dark:text-sage-300'
                : 'bg-muted text-muted-foreground',
            )}
          >
            <Vault className="h-6 w-6" weight="regular" aria-hidden />
          </span>
          <div className="min-w-0 flex-1">
            <p className="font-display text-[15px] font-semibold text-foreground">
              {copy.vaultName}
            </p>
            <p
              className={cn(
                'mt-0.5 text-[12.5px]',
                enabled ? 'text-muted-foreground' : 'text-muted-foreground/80',
              )}
            >
              {enabled
                ? copy.vaultOnHint.replace('{amount}', amountFmt)
                : copy.vaultOffHint}
            </p>
          </div>
          <span
            className={cn(
              'relative h-[26px] w-11 shrink-0 rounded-[13px]',
              enabled ? 'bg-sage-600' : 'bg-stone-300 dark:bg-stone-600',
            )}
            aria-hidden
          >
            <span
              className={cn(
                'absolute top-[3px] h-5 w-5 rounded-full bg-white transition-all',
                enabled ? 'right-[3px]' : 'left-[3px]',
              )}
            />
          </span>
        </div>
      </button>

      <p className="m-0 text-center text-xs text-muted-foreground">{copy.footerHint}</p>
    </div>
  );
}

export default DebtVaultStep;
